var _def, _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    id: "react-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _def || (_def = /*#__PURE__*/React.createElement("def", null, /*#__PURE__*/React.createElement("style", null, "\n      @keyframes react-ani {\n      0% {\n      stroke-dashoffset: -176;\n      }\n      50% {\n      stroke-dashoffset: 0;\n      }\n      100% {\n      stroke-dashoffset: 176;\n      }\n      }\n      #react-icon {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      width: 100px;\n      height: 100px;\n      }\n      .react-ellipse {\n      fill: none;\n      stroke: #61dafb;\n      stroke-miterlimit: 10;\n      stroke-width: 3px;\n      stroke-dasharray: 176;\n      stroke-dashoffset: -176;\n      animation: react-ani 0.7s infinite ease-in-out;\n      opacity: 1;\n      }\n      .react-ellipse-2 {\n      transform-origin: 50px 50px;\n      transform: rotate(57deg);\n      animation-delay: 0.1s;\n      }\n\n      .react-ellipse-3 {\n      transform-origin: 50px 50px;\n      transform: rotate(123deg);\n      animation-delay: 0.2s;\n      }\n    "))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "react-ellipse",
    cx: 50,
    cy: 50,
    rx: 40,
    ry: 12
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "react-ellipse react-ellipse-2",
    cx: 50,
    cy: 50,
    rx: 40,
    ry: 12
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "react-ellipse react-ellipse-3",
    cx: 50,
    cy: 50,
    rx: 40,
    ry: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactIcon);
export default __webpack_public_path__ + "static/media/react-icon.eb124ea17db3f8f2070a4ca3929aec28.svg";
export { ForwardRef as ReactComponent };